import { render, staticRenderFns } from "./SingleEmployer.vue?vue&type=template&id=67964972&"
import script from "./SingleEmployer.vue?vue&type=script&lang=js&"
export * from "./SingleEmployer.vue?vue&type=script&lang=js&"
import style0 from "./SingleEmployer.vue?vue&type=style&index=0&id=67964972&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports